import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    alertMessage: "",
};

export const alertSlice = createSlice({
    name: "alert",
    initialState,
    reducers: {
        setMessage: (state, action) => {
            state.alertMessage = action.payload;
        },
        clearMessage: (state) => {
            state.alertMessage = "";
        },
    },
});

export const { setMessage, clearMessage } = alertSlice.actions;

export default alertSlice.reducer;
